import LegalLayout, { LegalSection } from "./LegalLayout";
import { LEGAL } from "../../lib/legal";

export default function CookiePolicy() {
    return (
        <LegalLayout title="Cookie Policy" version={LEGAL.cookieVersion} testid="cookie-page">
            <LegalSection>
                <p>
                    La presente Cookie Policy descrive i cookie e le tecnologie di archiviazione locale
                    utilizzati dalla piattaforma, in conformità alle Linee guida del Garante Privacy e
                    alla Direttiva ePrivacy.
                </p>
            </LegalSection>

            <LegalSection title="1. Cookie tecnici (necessari)">
                <p>
                    La piattaforma utilizza esclusivamente cookie <strong>tecnici e di sessione</strong>,
                    indispensabili per il funzionamento e la sicurezza del Servizio. Per tali cookie non è
                    richiesto il consenso.
                </p>
                <div className="border border-gray-200 mt-2">
                    <table className="w-full text-xs">
                        <thead className="bg-gray-50 text-left">
                            <tr>
                                <th className="p-2 font-bold">Nome</th>
                                <th className="p-2 font-bold">Finalità</th>
                                <th className="p-2 font-bold">Durata</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-t border-gray-100">
                                <td className="p-2 font-mono">access_token</td>
                                <td className="p-2">Autenticazione della sessione (HttpOnly, Secure)</td>
                                <td className="p-2">12 ore</td>
                            </tr>
                            <tr className="border-t border-gray-100">
                                <td className="p-2 font-mono">refresh_token</td>
                                <td className="p-2">Rinnovo della sessione (HttpOnly, Secure)</td>
                                <td className="p-2">7 giorni</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </LegalSection>

            <LegalSection title="2. Archiviazione locale (localStorage)">
                <p>
                    Per migliorare l&apos;esperienza d&apos;uso vengono salvate alcune preferenze nel
                    browser (es. presa visione del banner cookie, completamento dell&apos;onboarding,
                    token di accesso applicativo). Si tratta di informazioni tecniche, non utilizzate per
                    profilazione.
                </p>
            </LegalSection>

            <LegalSection title="3. Cookie di profilazione e di terze parti">
                <p>
                    Allo stato <strong>non sono utilizzati</strong> cookie di profilazione, di marketing o
                    di analytics di terze parti. Qualora in futuro venissero introdotti, sarà mostrato un
                    banner con possibilità di consenso granulare e la presente Policy sarà aggiornata.
                </p>
            </LegalSection>

            <LegalSection title="4. Gestione dei cookie">
                <p>
                    L&apos;utente può gestire o eliminare i cookie tramite le impostazioni del proprio
                    browser. La disabilitazione dei cookie tecnici può compromettere il corretto
                    funzionamento del Servizio (es. impossibilità di mantenere l&apos;accesso).
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
